<label class="visually-hidden" [attr.for]="labelId">{{ label }}</label>
<ng-select
  class="linked-items-select"
  [labelForId]="labelId"
  [placeholder]="placeholder"
  [items]="linkedItemList$ | async"
  bindLabel="title"
  [minTermLength]="2"
  [loading]="isLoading"
  typeToSearchText="Please enter 2 or more characters"
  [typeahead]="searchInput$"
  [hideSelected]="true"
  [clearable]="!isMulti"
  [(ngModel)]="internalSelectedLinkedItem"
  (change)="linkedItemSelected($event); select.blur()"
  #select>
  <ng-template ng-option-tmp let-item="item">
    <div
      class="d-flex align-items-center justify-content-between linked-item-option-row">
      <div class="linked-item-title-ellipsis">{{ item.link_title }}</div>
      <div class="opacity-50" ngbTooltip="{{ getLinkedItemTypeLabel(item) }}">
        <span *ngIf="shouldShowDate(item)" class="fs-14 me-1">
          {{ item.parent_start_datetime! | formatDateMMDDYY
          }}{{
            shouldShowEndDate(item)
              ? " - " + (item.parent_end_datetime! | formatDateMMDDYY)
              : ""
          }}
        </span>
        <i
          class="bi text-primary"
          [ngClass]="'bi-' + getLinkedItemIcon(item)"></i>
      </div>
    </div>
  </ng-template>
</ng-select>

<ng-container
  *ngIf="emptyStateMessage && internalSelectedLinkedItemList.length === 0">
  <div class="my-3 text-center fs-14">
    No Linked Items found.<br />{{ emptyStateMessage }}
  </div>
</ng-container>
<ng-container *ngFor="let item of internalSelectedLinkedItemList">
  <div class="card border border-secondary border-3 text-center p-3 mt-2">
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center linked-item-card-content">
        <div class="text-primary opacity-50 me-3">
          <i class="bi fs-28" [ngClass]="'bi-' + getLinkedItemIcon(item)"></i>
        </div>
        <div class="text-start linked-item-text-wrap">
          <ng-container *ngIf="canOpenLink(item); else linkedItemTitleText">
            <a
              href="{{ item.link_url }}"
              target="_blank"
              class="d-block fw-semibold linked-item-title-ellipsis mb-1"
              >{{ item.link_title }}</a
            >
          </ng-container>
          <ng-template #linkedItemTitleText>
            <span class="d-block fw-semibold linked-item-title-ellipsis mb-1">
              {{ item.link_title }}
            </span>
          </ng-template>
          <div class="fs-13">
            <span class="text-muted me-1">{{
              getLinkedItemTypeLabel(item)
            }}</span>
            <span *ngIf="shouldShowDate(item)" class="opacity-50">
              {{ item.parent_start_datetime! | formatDateMMDDYY
              }}{{
                shouldShowEndDate(item)
                  ? " - " + (item.parent_end_datetime! | formatDateMMDDYY)
                  : ""
              }}
            </span>
          </div>
        </div>
      </div>
      <button
        (click)="removeLinkedItemFromList(item)"
        aria-label="Remove linked item button"
        class="btn btn-delete btn-sm"
        type="button"
        ngbTooltip="Remove Item"
        [autoClose]="'outside'">
        <i class="bi bi-x-circle-fill"></i>
      </button>
    </div>
  </div>
</ng-container>
<app-create-session-modal #createSessionModal />
<div class="text-center mt-4" *ngIf="includeCoachingSessionsSource">
  <button
    type="button"
    class="btn btn-primary py-1 px-2 fs-15"
    [ngbTooltip]="createSessionTooltip"
    placement="bottom"
    (click)="openCreateSessionModal()">
    <i class="bi bi-plus"></i> Create a Session
  </button>
</div>
